module.exports = __webpack_public_path__ + "img/promo-code.4dd8badf.svg";